import api from 'api/instance';

const URL = `${process.env.REACT_APP_API_URL}/admin/quickListing`;

export type GetAllResponse = {
  data: {
    logs: any;
    analytics: any;
  };
  meta: {
    count: number;
    page: number;
    limit: number;
  };
};

const getQuickListingLogs = async (
  payload?: string
): Promise<GetAllResponse> => {
  const { data } = await api.get<GetAllResponse>(`${URL}${payload}`);
  return data;
};

const getQuickListingDetails = async (id: string): Promise<any> => {
  const { data } = await api.get<{ data: any }>(`${URL}/${id}`);
  return data.data;
};

export default {
  getQuickListingLogs,
  getQuickListingDetails,
};
